<template>
  <div class="commodity-detail">
    <div class="title-default">
      <i class="goback" @click="$router.go(-1)">我的商品</i> /
      <span>商品详情</span>
    </div>
    <div class="commodity-detail-content">
      <div class="label-default">
        <div class="input-title">商品名称：</div>
        {{ goodsData.name }}
      </div>
      <div class="label-default">
        <div class="input-title">商品类别：</div>
        {{ goodsData.goodsTypeName }}
      </div>
      <div class="label-default detail-url">
        <div class="input-title">店铺商品链接：</div>
        <a :href="goodsData.shopUrl" target="_blank" style="color=#3455D3;">{{
          goodsData.shopUrl
        }}</a>
      </div>
      <div class="label-default detail-content">
        <div class="input-title">商品描述：</div>
        {{ goodsData.description }}
      </div>
      <div class="label-default">
        <div class="input-title">商品图片：</div>
        <el-image v-if="goodsData.imgUrl" :src="goodsData.imgUrl" :preview-src-list="srcList" lazy>
        </el-image>
      </div>
      <div class="label-default" v-if="!!goodsData.installVideoUrl">
        <div class="input-title">安装视频：</div>
        <video width="547" height="323" controls>
          <source :src="goodsData.installVideoUrl" type="video/mp4" />
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goodsData: {},
      srcList: [],
      imgUrl:''
      // imgUrl=http://cdqdsyfile.oss-cn-shanghai.aliyuncs.com/20211110101356375059.png
    };
  },
  mounted() {
    var _this = this;
    this.$post(`/user/api/goods/get?id=${_this.$route.query.id}`).then(res => {
      if (res.code == 0) {
        _this.goodsData = res.data;
        _this.srcList.push(res.data.imgUrl);
      } else {
        this.$message(res.message);
      }
    });
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
.commodity-detail {
  background: #fff;
  margin-bottom: 100px;
  .commodity-detail-content {
    padding: 16px 20px 24px 20px;
    .label-default {
      color: #2f3133;
      margin-bottom: 40px;
      line-height: 1;
      .input-title {
        margin-bottom: 14px;
      }
      & /deep/ .el-image {
        width: 100px;
        height: 100px;
        & > img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .label-default:last-child {
      margin-bottom: 0;
    }
    .detail-content {
      line-height: 24px;
    }
  }
}
</style>
